//* 组件库
import type { UiTypes } from "various-ui";
//* 组件属性
import type { VideosData, VideosOrigin } from "../index";

export const useComposable = () => {
    //* 响应式数据
    const refs = {
        keywords: ref<string>(""),
        filter: ref<string>(""),
        filters: ref<UiTypes.candidate[]>([]),
        data: ref<VideosData[]>([]),
        main: ref<string>(""),
        cover: ref<string>(""),
    };

    //* 函数
    const methods = {
        //* 渲染函数
        render: async (data?: VideosOrigin) => {
            if (!data) return;
            //* 数据初始化
            refs.cover.value = data.cover;
            refs.main.value = data.main;
            refs.data.value = data.data || [];
        },
    };

    return { refs, methods };
};
